import React from "react";
import { Box, Heading, Text, Button } from "grommet";
import { Info, LinkPrevious, MailOption } from "grommet-icons";
import { useNavigate } from "react-router-dom";
import VideoTutorialsGrid from "../components/ManagerPortal/VideoTutorialsGrid";
import { StickyFooter } from "../components/Footers/GlobalFooter";
import { HeaderNavigation } from "../components/Headers/GlobalHeader";

const ContactPage = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <HeaderNavigation />
      <Box>
        <Box
          direction="row"
          align="center"
          gap={"small"}
          margin={{ vertical: "xsmall" }}
        >
          <Button
            icon={<LinkPrevious />}
            onClick={() => navigate(-1)}
            color="brand"
            size="large"
          />
          <Heading level="2" margin="none">
            Self guided help
          </Heading>
        </Box>
        <Box
          border={{ color: "brand", size: "xsmall", side: "bottom" }}
          width="full"
        />
      </Box>

      <Box
        margin={{ top: "medium", horizontal: "medium" }}
        direction="row"
        gap="small"
        pad="small"
        background="white"
        elevation="small"
        round="small"
        border={{ color: "brand", size: "xsmall" }}
        width="auto"
        alignSelf="center"
      >
        <Info size="medium" color="brand" alignSelf="center" />
        <Text>
          If a manager invites a user, that user will not be able to directly
          upgrade to a manager. Instead, they would need to contact the support
          team for the upgrade.
        </Text>
      </Box>

      <Box pad="large" align="center" gap="medium">
        <Box>
          <Heading level={3} margin="none" textAlign="center">
            Watch Our Tutorials
          </Heading>
          <Text margin={{ bottom: "small" }} textAlign="center">
            Explore our video tutorials to get the most out of HPE Digital Skill Advisor.
          </Text>
        </Box>
        {/* Video Tutorials Section */}
        <Box width="xlarge" pad="medium" background="light-1" round="small">
          <Box align="center">
            <VideoTutorialsGrid />
          </Box>
        </Box>

        {/* Contact Support Section */}
        <Box
          width="large"
          pad="medium"
          background="light-2"
          round="small"
          elevation="small"
        >
          <Heading level={2} margin="none" textAlign="center">
            Contact Us
          </Heading>
          <Text textAlign="center" size="large" margin={{ top: "small" }}>
            Need help with <strong>HPE Digital Skill Advisor</strong>? Get in touch with us
            for support.
          </Text>

          <Box align="center" margin={{ top: "medium" }}>
            <Button
              label="Email Support"
              icon={<MailOption />}
              href="mailto: hpeskill.advisor@hpe.com?subject=Support%20needed%20for%20HPE%20Digital%20Skill%20Advisor&body=Hi%2C%0A%0APlease%20provide%20details%20of%20the%20issue%20you%20are%20facing%20with%20HPE%20Digital%20Skill%20Advisor%20in%20this%20email.%20We%20will%20review%20your%20request%2C%20and%20get%20back%20to%20you%20within%2048%20hours.%0A%0AIf%20you%20have%20any%20screenshots%20or%20media%20content%20to%20highlight%20your%20issue%2C%20please%20attach%20it%20to%20this%20email.%0A%0ABest%20Wishes%2C%0AHPE%20Digital%20Skill%20Advisor"
              primary
            />
          </Box>
        </Box>
      </Box>

      <StickyFooter />
    </Box>
  );
};

export default ContactPage;
